var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27.5,
    r: 27,
    fill: "url(#paint0_linear_264_21165)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.857 36.75H21.7503C21.027 36.75 20.3853 36.7267 19.8137 36.645C16.7453 36.3067 15.917 34.86 15.917 30.9167V25.0833C15.917 21.14 16.7453 19.6933 19.8137 19.355C20.3853 19.2733 21.027 19.25 21.7503 19.25H25.787",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5234 19.25H32.2501C32.9734 19.25 33.6151 19.2733 34.1868 19.355C37.2551 19.6933 38.0834 21.14 38.0834 25.0833V30.9167C38.0834 34.86 37.2551 36.3067 34.1868 36.645C33.6151 36.7267 32.9734 36.75 32.2501 36.75H30.5234",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16.3334V39.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9431 28H25.9536",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2771 28H21.2876",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_21165",
    x1: 0,
    y1: 0.5,
    x2: 54,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#6CA5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#3A85F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.54be29e55a8aa26905a8ff2461393a28.svg";
export { ForwardRef as ReactComponent };